import { efaProductDetails } from './efa-product-details-de.i18n';

export const de = {
  efaProductDetails
};
